import React from 'react';
import { Alert, Button } from 'antd';
import { StyledAlertValidationInstallation } from './AlertValidationInstallation.styles';

interface AlertValidationInstallationProps {
  message: string;
  description: string;
  onClose: () => void;
  onRefresh: () => void;
}

const AlertValidationInstallation: React.FC<AlertValidationInstallationProps> = ({
  message,
  description,
  onClose,
  onRefresh,
}) => {
  return (
    <StyledAlertValidationInstallation>
      <Alert
        message={message}
        description={description}
        type="info"
        showIcon
        action={
          <Button size="small" type="primary" onClick={onRefresh} className="installer-alert-test-button">
            Refresh
          </Button>
        }
        closable
        onClose={onClose}
      />
    </StyledAlertValidationInstallation>
  );
};
export default AlertValidationInstallation;
